export enum CondicionIVA {
    ConsumidorFinal = 0,
    ResponsableInscripto = 1
}